import { Wallet } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/** Тариф, потребление, счета, акты и оплата (ПОРТ-30…35; матрица 2.2 «Тариф, счета, оплата»: OWNER и ACCOUNTANT). */
export const section = defineSection({
  id: 'billing.account',
  area: 'clinic',
  path: 'billing/*',
  roles: ['OWNER', 'ACCOUNTANT'],
  icon: Wallet,
  titleKey: 'billing:title',
  namespaces: ['portal'],
  navGroup: 'manage',
  order: 22,
  tabGroup: 'clinic',
  load: () => import('./BillingPage'),
});
